import { IonCard, IonContent, IonPage } from "@ionic/react";
import { useUsersStore } from "../stores/users.store";
import Header from "../components/Header";
import ProfileCard from "../components/ProfileCard";
import { ReactComponent as BotIcon } from "../assets/graphics/robot.svg";
import { ReactComponent as LobbiesIcon } from "../assets/graphics/Vector.svg";
import QuoQuestCard from "../components/QuoQuestCard";
import ChallengeCard from "../components/ChallengeCard";
import { useBotsStore } from "../stores/bots.store";
import { useAuthStore } from "../stores/auth.store";
import BotListItem from "../components/BotListItem";

const Dashboard: React.FC = () => {
  const showTour = useUsersStore(state => state.showTour);
  const uid = useAuthStore(state => state.user?.uid);
  const liveBot = useBotsStore(state =>
    state.bots.find(
      bot => bot.active && bot.user === uid && bot.mode === "live"
    )
  );

  return (
    <IonPage>
      <Header title="Dashboard" classes={showTour ? "blur-lg" : ""} />
      <IonContent
        fullscreen
        className={showTour ? "blur-lg" : ""}
        scroll-y="false"
      >
        <div className="p-2 flex flex-col items-center max-w-lg mx-auto px-4">
          <ProfileCard />

          {liveBot && (
            <div className="my-2 w-full p-2 border border-primary-50 rounded-lg max-w-lg mx-auto cursor-pointer">
              <BotListItem index={1} bot={liveBot} hideEarnings />
            </div>
          )}

          <div className="flex gap-2 pt-2">
            <IonCard
              className="bg-gradient-ternary text-white m-0 flex-1 rounded-lg"
              button
              routerLink="/bots"
            >
              <div className="w-full p-4 flex flex-col gap-2 items-start">
                <div className="flex items-center text-white text-lg">
                  <div className="ml-1">My Bots</div>
                </div>
                <div className="p-2 w-fit flex items-center justify-center opacity-50">
                  <BotIcon />
                </div>
                <span className="text-sl opacity-50">
                  Assemble an army of Trading bots!
                </span>
              </div>
            </IonCard>
            <IonCard
              className="bg-gradient-secondary text-white m-0 flex-1 rounded-lg"
              routerLink="/lobbies"
            >
              <div className="w-full p-4 flex flex-col gap-2 items-start">
                <div className="flex items-center text-white text-lg">
                  <div className="ml-1">Lobbies</div>
                </div>
                <div className="p-2 bg-blend-overlay w-fit flex items-center justify-center opacity-50">
                  <LobbiesIcon className="selected-fill" />
                </div>
                <span className="text-sl opacity-50">
                  Challenge others to the top!
                </span>
              </div>
            </IonCard>
          </div>
          <div className="flex flex-col justify-center items-center w-full">
            <ChallengeCard />
            <IonCard
              className="m-1 w-full h-20 flex justify-center items-center text-center text-white text-lg bg-primary-50"
              routerLink="/HelpCenter"
              button
            >
              Help Center
            </IonCard>
          </div>
          <div className="w-full pt-2 pb-1 mt-2">
            <QuoQuestCard />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Dashboard;
